import React from 'react';
import moment from 'moment';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { Avatar, MCButton } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import {
  addressObject,
  getSelectLabel,
  isAdminPage,
  lang,
  permissions,
  remCss,
  upperFirstChar,
  userFullName
} from 'src/helpers';

const { PAGES } = permissions;

class Basic extends BaseComponent {
  render() {
    const { patient } = this.props;
    return (
      <div className={'mc-container-content__body horizontal'} style={{ minWidth: remCss(610) }}>
        <div className={'mc-container-content__body-content mc-grow mc-flex-15-col border-right'}>
          <div className={'mc-flex-15-col mc-wrap'}>
            <Avatar image={patient.avatar} text={userFullName(patient)} width={80} height={80} />
            <div className={'mc-flex-col'}>
              <div className={'mc-value-622'}>{userFullName(patient)}</div>
              <div className={'mc-label-416'}>{patient.email}</div>
            </div>
          </div>
          <div className={'mc-value-518'}>{lang.t('Appointments')}</div>
          <div className={'mc-flex'}>
            <div className={'mc-total mc-grow'}>
              <div className={'mc-value-622'}>{patient.pastTotal || '-'}</div>
              <div className={'mc-label-416'}>{lang.t('Past')}</div>
            </div>
            <div className={'mc-total mc-grow'}>
              <div className={'mc-value-622'}>{patient.upcomingTotal || '-'}</div>
              <div className={'mc-label-416'}>{lang.t('Upcoming')}</div>
            </div>
          </div>
          <MCButton
            dark
            primary
            radius
            medium
            type={'link'}
            to={
              isAdminPage()
                ? PAGES.ADMIN_MESSAGES_USER_PAGE.match(patient.id)
                : PAGES.MESSAGES_USER_PAGE.match(patient.id)
            }
          >
            {lang.t('Send message')}
          </MCButton>
        </div>
        <div className={'mc-container-content__body-content mc-grow mc-flex-25-col'}>
          <div className={'mc-flex mc-flex-start'}>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Gender')}</div>
              <div className={'mc-value-518'}>
                {getSelectLabel(constants.general.gender, patient.gender)}
              </div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Birthday')}</div>
              <div className={'mc-value-518'}>
                {!!patient.birthday &&
                  moment(
                    patient.birthday,
                    patient.birthday.toString().length === 8 ? 'YYYYMMDD' : ''
                  ).format('MMMM DD, YYYY')}
                &nbsp;
              </div>
            </div>
          </div>
          <div className={'mc-flex mc-flex-start'}>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Phone')}</div>
              <div className={'mc-value-518'}>
                {formatPhoneNumberIntl((patient.phoneNumber || '').toString())}
              </div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Address')}</div>
              <div className={'mc-value-518'}>{patient.address}&nbsp;</div>
            </div>
          </div>
          <div className={'mc-flex mc-flex-start'}>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('City')}</div>
              <div className={'mc-value-518'}>{addressObject(patient).cityName}&nbsp;</div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('ZIP code')}</div>
              <div className={'mc-value-518'}>{patient.zipcode}&nbsp;</div>
            </div>
          </div>
          <div className={'mc-flex mc-flex-start'}>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Registration date')}</div>
              <div className={'mc-value-518'}>
                {moment(patient.created).format('MMMM DD, YYYY')}
              </div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Status')}</div>
              <button
                type={'button'}
                className={
                  'mc-status-' + (patient.status === 'disabled' ? 'cancelled' : patient.status)
                }
                style={{ width: remCss(120) }}
              >
                {upperFirstChar(patient.status)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Basic;
